import React from 'react';
import {FastField, ErrorMessage} from 'formik';
import {FormattedMessage} from 'react-intl';
import Error from '../Error';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';

const FormGroupRadio = ({id, name, label, value, icon, ...rest}) => (
    <FastField name={name}>
        {({field}) => (
            <div className="custom-control custom-radio">
                <input type="radio" name={field.name} id={id} value={value}
                    checked={field.value === value} onChange={field.onChange} className="custom-control-input"
                    {...rest} />
                <label htmlFor={id} className="custom-control-label">
                    {icon && <FontAwesomeIcon icon={icon} size="lg" className="custom-control-icon" />}
                    <FormattedMessage {...label} />
                </label>
                <ErrorMessage name={name}>{(message) => <Error reason={message.key} reasonParams={message.params} />}</ErrorMessage>
            </div>
        )}
    </FastField>
);

export default FormGroupRadio;
